import { render } from "./SwiperDetailsComponent.vue?vue&type=template&id=015b8e17&scoped=true"
import script from "./SwiperDetailsComponent.vue?vue&type=script&lang=js"
export * from "./SwiperDetailsComponent.vue?vue&type=script&lang=js"

import "./SwiperDetailsComponent.vue?vue&type=style&index=0&id=015b8e17&lang=scss&scoped=true"

import exportComponent from "H:\\_LK\\_FINISHED PROJECTS\\photographer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-015b8e17"]])

export default __exports__